import React, { forwardRef, useState, useEffect } from "react";
import apiService from "apiService";
import Select2 from "react-select";
import Alert from "view/component/Alert";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { confirmedAlert } from "../../component/Alert";
import moment from "moment";
import Table from "../../component/Table1";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import API from "../../../apiService";

const MySwal = withReactContent(Swal);

const PregnantHistory = (props) => {

  const hphtToHpl = (hpht = moment()) => {
    let tgl = hpht
    if (tgl.month() + 1 === 1 || tgl.month() + 1 === 2 || (tgl.month() + 1 === 3 && tgl.date() < 25)) {
      tgl = tgl.add(7, 'day')
      tgl = tgl.add(9, 'month')
    }
    else {
      tgl = tgl.add(7, 'day')
      tgl = tgl.subtract(3, 'month')
      tgl = tgl.add(1, 'year')
    }
    return tgl.format("YYYY-MM-DD")
  }

  const [refPregnantHistory, setRefPregnantHistory] = useState([]);
  const [sex, setSex] = useState([]);
  const [paramedic, setParamedic] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const [facility, setFacility] = useState([]);
  const [blood, setBlood] = useState([]);
  const [param, setParam] = useState({
    visit_id: props.detilPx.id,
    g: 0,
    p: 0,
    a: 0,
    hpht: moment().format("YYYY-MM-DD"),
    htp: hphtToHpl(),
    alive_child: 0,
    dead_child: 0,
    premature_child: 0,
    married_year: moment().format("YYYY"),
    childbirth_interval: 0,
    lila: 0,
    weight: 0,
    height: 0,
    imt: 0,
    blood_type: 0,
    blood_type_obj: 0,
    immunization_screening_tt: "TT1",
    immunization: {
      value: "TT1",
      label: "TT1",
    },
    medical_facilities_other: false,
    medical_facilities_other_age: 0,
    medical_facilities_other_health_facility_id: 1,
    medical_facility: {
      value: 1,
      label: "Puskesmas Lain",
    },
    risk_factor: "",
    complication: "",
    found_by: "nakes",
    husband_name: "",
    husband_phone: "",
  });

  const [history, setHistory] = useState({
    visit_id: props.detilPx.id,
    abortus: 0,
    preterm: 0,
    aterm: 0,
    postterm: 0,
    delivery_method_id: 1,
    delivery_method: {
      value: 1,
      label: "Normal/Spontan",
    },
    paramedic_type_id: 0,
    paramedic_types: {
      value: 1,
      label: "Dokter",
    },
    baby_condition: "hidup",
    sex: 1,
    s: {
      value: 1,
      label: "Laki-laki",
    },
    weight: 0,
    breast_feeding: "",
    nifas_condition: "sehat",
    explanation: "",
  });

  const getBloodType = async () => {
    const res = await API.get("management/blood_types/read");
    if (res.code === 200) {
      setBlood(res.data)
    }
  }

  const getDelivery = async () => {
    let res = await apiService.get("/management/deliveries/read");
    if (res && res.code === 200) {
      setDelivery(res.data);
    }
  };

  const getParamedic = async () => {
    let res = await apiService.get("/management/paramedic_types/read");
    if (res && res.code === 200) {
      setParamedic(res.data);
    }
  };

  const getSex = async () => {
    let res = await apiService.get("/management/sex/read");
    if (res && res.code === 200) {
      setSex(res.data);
    }
  };

  const getFacility = async () => {
    let res = await apiService.get("/management/health_facilities/read");
    if (res && res.code === 200) {
      setFacility(res.data);
    }
  };

  const getPregnant = async () => {
    let res = await apiService.get(
      "/registration/pregnant/read/" + props.detilPx.patient_id
    );
    if (res && res.code === 200) {
      setRefPregnantHistory(res.data);
    }
    console.log(res);
  };

  useEffect(() => {
    getFacility();
    getSex();
    getDelivery();
    getParamedic();
    getPregnant();
    getBloodType();
  }, [refPregnantHistory.length]);

  useEffect(() => {
    let bmi = param.weight / ((param.height/100)*(param.height/100))
    setParam({...param, imt: bmi})
  }, [JSON.stringify(param)])

  const postParam = async () => {
    let res = await apiService.post("/registration/pregnant/create", param);
    if (res.code === 200) {
      await apiService.post(`fhir/satu_sehat/episodeOfCare/${param.visit_id}`, {pregnant_id: res.data.id});
      await apiService.post(`fhir/satu_sehat/observation_bundle/${param.visit_id}`, {
        types: ['bb-sebelum-hamil', 'tb', 'imt-sebelum-hamil', 'lila', 'tt1-5', 'presentasi']
      });
      Alert("success", "data disimpan");
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getPregnant();
  };

  const postHistory = async (dataid) => {
    let da = history;
    da["pregnant_id"] = dataid;
    let res = await apiService.post(
      "/registration/pregnant_history/create",
      da
    );
    if (res.code === 200) {
      Alert("success", "data disimpan");
    } else {
      Alert("error", "gagal menyimpan data");
    }
    getPregnant();
  };

  const createButtonDelete = (datad) => {
    return (
      <button
        onClick={(e) => {
          confirmedAlert(
            "Konfirmasi",
            "Apakah anda akan menghapus data riwayat kehamilan?",
            function (confirmed) {
              if (confirmed) {
                delHistory(datad);
              }
            }
          );
        }}
        className='btn btn-sm btn-danger'>
        <span class='btn-inner--icon'>
          <i class='fas fa-minus'></i>
        </span>
      </button>
    );
  };

  const createButton = (datad) => {
    return (
      <button
        onClick={(e) => { }}
        className='btn btn-sm btn-secondary text-primary'>
        <span class='btn-inner--icon'>
          <i class='fas fa-print'></i>
        </span>
      </button>
    );
  };

  const delHistory = async (dataid) => {
    let res = await apiService.delete(
      "/registration/pregnant_history/delete/" + dataid
    );
    if (res.code === 200) {
      Alert("default", "data dihapus");
    } else {
      Alert("error", "gagal menghapus data");
    }
    getPregnant();
  };

  const delParam = async (dataid) => {
    let res = await apiService.delete(
      "/registration/pregnant/delete/" + dataid
    );
    if (res.code === 200) {
      Alert("default", "data dihapus");
    } else {
      Alert("error", "gagal menghapus data");
    }
    getPregnant();
  };
  const ref = React.createRef();
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
      className='btn btn-outline-secondary text-default m-0 btn-block'
      ref={ref}
      type='button'
      onClick={onClick}>
      {value}
    </button>
  ));
  const putSpecisif = (id, val, field, type, opt = null) => {
    let option = '';
    if (opt) {
      opt.forEach(element => {
        option += `<option value="${element}" ${val === element ? 'selected' : ''} >${element}</option>`
      });
    }
    MySwal.fire({
      title: 'Ubah Data ' + field.replace("_", " "),
      html: opt ? `<select id="data" class="custom-select">${option}</select>` : `<input type="${type}" value="${val}" id="data" class="form-control">`,
      showCancelButton: true,
      confirmButtonText: 'Simpan',
      preConfirm: () => {
        const data = Swal.getPopup().querySelector('#data').value
        if (!data) {
          Swal.showValidationMessage(`Data tidak boleh kosong`)
        }
        return { data: data }
      }
    }).then(async (d) => {
      if (d.isConfirmed) {
        let data = {};
        data[field] = d.value.data
        data['id'] = id

        if (field === 'hpht') {
          data['htp'] = hphtToHpl(moment(data[field]))
        }

        let params = {
          'data': data
        };

        let res = await apiService.put(
          "/registration/pregnant/specific",
          params
        );
        if (res.code === 200) {
          Alert("success", "Data berhasil di-update");
        } else {
          Alert("error", "Gagal meng-update data");
        }
        getPregnant();
      }
    });
  };
  return (
    <div>
      <div className='card'>
        <div className='card-header'>
          <div className='row align-items-center'>
            <div className='col-lg-9'>
              <h4 className='h3 mb-0'>Riwayat Kehamilan</h4>
            </div>
            <div className='col-lg-3'>
              <button
                data-toggle='collapse'
                data-target='#collapsePreview'
                aria-expanded='false'
                aria-controls='collapsePreview'
                className='btn btn-outline-primary btn-block'>
                Tambah Data Kehamilan
              </button>
            </div>
          </div>
        </div>
        <div className='collapse' id='collapsePreview'>
          <div className='card-header bg-secondary'>
            <div className='align-items-center'>
              <div className='list-group mb-4'>
                <div className='list-group-item mt-0 mb-0 bg-primary'>
                  <div className='h4 text-white'>DATA SUAMI</div>
                </div>
                <div className='list-group-item'>
                  <div className='row'>
                    <div className='col-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Nama Suami
                        </label>
                        <div className='input-group'>
                          <input
                              type='text'
                              value={param.husband_name}
                              onChange={(e) =>
                                  setParam({...param, husband_name: e.target.value})
                              }
                              className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          No Handphone Suami
                        </label>
                        <div className='input-group'>
                          <input
                              type='text'
                              value={param.husband_phone}
                              onChange={(e) =>
                                  setParam({...param, husband_phone: e.target.value})
                              }
                              className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='list-group-item mt-0 mb-0 bg-primary'>
                  <div className='h4 text-white'>DETAIL KEHAMILAN</div>
                </div>
                <div className='list-group-item'>
                  <div className='row'>
                    <div className='col-12'>
                      <div className='form-group'>
                        <div className='custom-control custom-checkbox'>
                          <input
                            type='checkbox'
                            className='custom-control-input'
                            id='customCheck1'
                            checked={
                              param.medical_facilities_other ? "checked" : ""
                            }
                            onChange={(e) => {
                              setParam({
                                ...param,
                                medical_facilities_other: !param.medical_facilities_other,
                              });
                            }}
                          />
                          <label
                            htmlFor='customCheck1'
                            className='custom-control-label'>
                            Berkunjung ke nakes lain sebelumnya?
                          </label>
                        </div>
                      </div>
                    </div>
                    {param.medical_facilities_other ? (
                      <>
                        <div className='col-6'>
                          <div className='form-group'>
                            <label className='form-control-label'>
                              Umur Kehamilan
                            </label>
                            <div className='input-group'>
                              <input
                                type='number'
                                value={param.medical_facilities_other_age}
                                onChange={(e) =>
                                  setParam({
                                    ...param,
                                    medical_facilities_other_age:
                                      e.target.value,
                                  })
                                }
                                className='form-control'
                              />
                              <div className='input-group-append'>
                                <span className='input-group-text text-default bg-secondary'>
                                  minggu
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-6'>
                          <div className='form-group'>
                            <label className='form-control-label'>Tempat</label>
                            <Select2
                              className='form-control p-0 pt-1'
                              styles={{
                                control: (styles) => ({
                                  ...styles,
                                  backgroundColor: "white",
                                  border: "none",
                                }),
                              }}
                              value={param.medical_facility}
                              onChange={(e) =>
                                setParam({
                                  ...param,
                                  medical_facilities_other_health_facility_id:
                                    e.value,
                                  medical_facility: e,
                                })
                              }
                              options={facility.map((data) => ({
                                value: data.id,
                                label: data.name,
                              }))}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className='col-12'>
                      <label className='form-control-label'>
                        Riwayat Persalinan
                      </label>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              G (Gravida)
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.g}
                            onChange={(e) => {
                              if (e.target.value >= 0)
                                setParam({
                                  ...param,
                                  g: parseInt(e.target.value),
                                  p: 0,
                                  a: 0,
                                });
                            }}
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              P (Paritas)
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.p}
                            onChange={(e) => {
                              if (
                                parseInt(e.target.value) + parseInt(param.a) <
                                parseInt(param.g) &&
                                e.target.value >= 0
                              )
                                setParam({
                                  ...param,
                                  p: parseInt(e.target.value),
                                });
                            }}
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              A (Abortus)
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.a}
                            onChange={(e) => {
                              if (
                                parseInt(param.p) + parseInt(e.target.value) <
                                parseInt(param.g) &&
                                e.target.value >= 0
                              )
                                setParam({
                                  ...param,
                                  a: parseInt(e.target.value),
                                });
                            }}
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-12'>
                      <label className='form-control-label'>
                        HPHT & HPL
                      </label>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <div className='input-group customDatePickerWidth'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              HPHT
                            </span>
                          </div>
                          <div className='form-control p-0'>
                            <DatePicker
                              value={param.hpht}
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  hpht: moment(e).format("YYYY-MM-DD"),
                                  htp: hphtToHpl(moment(e))
                                })
                              }}
                              dateFormat='YYYY-MM-DD'
                              customInput={<ExampleCustomInput ref={ref} />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <div className='input-group customDatePickerWidth'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              HPL
                            </span>
                          </div>
                          <div className='form-control p-0'>
                            <DatePicker
                              value={param.htp}
                              onChange={(e) =>
                                setParam({
                                  ...param,
                                  htp: moment(e).format("YYYY-MM-DD")
                                })
                              }
                              dateFormat='YYYY-MM-DD'
                              customInput={<ExampleCustomInput ref={ref} />}
                            />
                          </div>
                          {/* <input
                            disabled
                            type='text'
                            value={param.htp}
                            className='form-control'
                          /> */}
                        </div>
                      </div>
                    </div>
                    <div className='col-12'>
                      <label className='form-control-label'>
                        Jumlah Anak
                      </label>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              Hidup
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.alive_child}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                alive_child: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              Mati
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.dead_child}
                            onChange={(e) =>
                              setParam({ ...param, dead_child: e.target.value })
                            }
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <div className='input-group'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text text-white bg-primary border-primary'>
                              Prematur
                            </span>
                          </div>
                          <input
                            type='number'
                            value={param.premature_child}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                premature_child: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Tahun Pernikahan
                        </label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={param.married_year}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                married_year: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                          <div className='input-group-append'>
                            <span className='input-group-text text-default bg-secondary'>
                              YYYY
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Jarak Dengan Persalinan Sebelumnya
                        </label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={param.childbirth_interval}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                childbirth_interval: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                          <div className='input-group-append'>
                            <span className='input-group-text text-default bg-secondary'>
                              Tahun
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>LILA</label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={param.lila}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                lila: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                          <div className='input-group-append'>
                            <span className='input-group-text text-default bg-secondary'>
                              cm
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Berat Badan Sebelum Hamil
                        </label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={param.weight}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                weight: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                          <div className='input-group-append'>
                            <span className='input-group-text text-default bg-secondary'>
                              kg
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Tinggi Badan
                        </label>
                        <div className='input-group'>
                          <input
                            type='number'
                            value={param.height}
                            onChange={(e) =>
                              setParam({
                                ...param,
                                height: e.target.value,
                              })
                            }
                            className='form-control'
                          />
                          <div className='input-group-append'>
                            <span className='input-group-text text-default bg-secondary'>
                              cm
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          IMT
                        </label>
                        <div className='input-group'>
                          <input
                              type='number'
                              value={param.imt}
                              onChange={(e) =>
                                  setParam({
                                    ...param,
                                    imt: e.target.value,
                                  })
                              }
                              className='form-control'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Screening Imunisasi TT
                        </label>
                        <Select2
                          className='form-control p-0 pt-1'
                          styles={{
                            control: (styles) => ({
                              ...styles,
                              backgroundColor: "white",
                              border: "none",
                            }),
                          }}
                          value={param.immunization}
                          onChange={(e) =>
                            setParam({
                              ...param,
                              immunization_screening_tt: e.value,
                              immunization: e,
                            })
                          }
                          options={[
                            {
                              value: "TT1",
                              label: "TT1",
                            },
                            {
                              value: "TT2",
                              label: "TT2",
                            },
                            {
                              value: "TT3",
                              label: "TT3",
                            },
                            {
                              value: "TT4",
                              label: "TT4",
                            },
                            {
                              value: "TT5",
                              label: "TT5",
                            },
                          ]}
                        />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Golongan Darah
                        </label>
                        <Select2
                            className='form-control p-0 pt-1'
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                backgroundColor: "white",
                                border: "none",
                              }),
                            }}
                            value={param.blood_type_obj}
                            onChange={(e) => {
                              setParam({...param, blood_type: e.value, blood_type_obj: e})
                            }}
                            options={blood.map(blood => ({value: blood.id, label: blood.name}))}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='list-group-item mt-0 mb-0 bg-primary'>
                  <div className='h4 text-white'>
                    FAKTOR RISIKO & KOMPLIKASI
                  </div>
                </div>
                <div className='list-group-item'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Faktor Risiko
                        </label>
                        <textarea
                          className='form-control'
                          onChange={(e) =>
                            setParam({ ...param, risk_factor: e.target.value })
                          }
                          value={param.risk_factor}
                          rows='3'
                        />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='form-group'>
                        <label className='form-control-label'>Komplikasi</label>
                        <textarea
                          className='form-control'
                          onChange={(e) =>
                            setParam({ ...param, complication: e.target.value })
                          }
                          value={param.complication}
                          rows='3'
                        />
                      </div>
                    </div>
                    <div className='col'>
                      <div className='form-group'>
                        <label className='form-control-label'>
                          Ditemukan oleh
                        </label>
                        <div className='form-control'>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInline1'
                              name='customRadioInline1'
                              className='custom-control-input'
                              value='nakes'
                              checked={
                                param.found_by === "nakes" ? "checked" : ""
                              }
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  found_by: e.target.value,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInline1'
                              className='custom-control-label'>
                              Nakes
                            </label>
                          </div>
                          <div className='custom-control custom-radio custom-control-inline'>
                            <input
                              type='radio'
                              id='customRadioInline2'
                              name='customRadioInline1'
                              className='custom-control-input'
                              value='masyarakat'
                              checked={
                                param.found_by === "masyarakat" ? "checked" : ""
                              }
                              onChange={(e) => {
                                setParam({
                                  ...param,
                                  found_by: e.target.value,
                                });
                              }}
                            />
                            <label
                              htmlFor='customRadioInline2'
                              className='custom-control-label'>
                              Masyarakat
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button className='btn btn-primary mb-2' onClick={() => postParam()}>
                Simpan Data Kehamilan
              </button>
              <button
                className='btn btn-outline-dark mb-2'
                data-toggle='collapse'
                data-target='#collapsePreview'
                aria-expanded='false'
                aria-controls='collapsePreview'>
                Tutup
              </button>
            </div>
          </div>
        </div>
        <div className='card-body bg-light'>
          <div className='accordion'>
            {refPregnantHistory.map((data, key) =>
              data.log === false ? (
                <div className='card' key={key}>
                  <div
                    className='card-header collapsed'
                    id={"headinglab" + key}
                    data-toggle='collapse'
                    data-target={"#collapselab" + key}
                    aria-expanded='false'
                    aria-controls={"collapselab" + key}>
                    <div className='row align-items-center'>
                      <div className='col'>
                        <div className='mb-0 text-default'>
                          Tanggal Kunjungan{" "}
                          {moment(data.created_at).format("DD-MM-YYYY HH:mm")}
                        </div>
                        <div className='h3 mb-0 text-default h4'>
                          Paramedis {data.users.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='collapse'
                    id={"collapselab" + key}
                    aria-labelledby={"headinglab" + key}>
                    <div className='card-body'>
                      <div className='list-group mb-4'>
                        <div className='list-group-item mt-0 mb-0'>
                          <div className='h4 text-center mb-0'>DETAIL KEHAMILAN</div>
                          <div className='text-sm text-center'><mark>Klik pada data untuk melakukan update</mark></div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            {data.medical_facilities_other ? (
                              <>
                                <div className='col-12'>
                                  <span className=''>
                                    Berkunjung ke nakes lain sebelumnya
                                  </span>
                                </div>
                                <div className='col-1'></div>
                                <div className='col-3'>
                                  <span className=''>Umur Kehamilan</span>
                                </div>
                                <div className='col-8'>
                                  <span className='h4'>
                                    {data.medical_facilities_other_age} minggu
                                  </span>
                                </div>
                                <div className='col-1'></div>
                                <div className='col-3'>
                                  <span className=''>Tempat</span>
                                </div>
                                <div className='col-8'>
                                  <span className='h4'>
                                    {data.health_facilities?.name}
                                  </span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className='col-12'>
                                  <span className='text-muted'>
                                    Tidak berkunjung ke nakes lain sebelumnya
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>Data Suami</span>
                            </div>
                            <div className='col-md-8'>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  Nama Suami
                                </label>
                                <button
                                    onClick={() => {
                                      putSpecisif(data.id, data.husband_name, 'husband_name', 'text');
                                    }}
                                    className='btn btn-secondary border-light'>
                                  {data.husband_name}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  No Handphone Suami
                                </label>
                                <button
                                    onClick={() => {
                                      putSpecisif(data.id, data.husband_phone, 'husband_phone', 'text');
                                    }}
                                    className='btn btn-secondary border-light'>
                                  {data.husband_phone}
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>Riwayat Persalinan</span>
                            </div>
                            <div className='col-md-8'>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  G
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.g, 'g', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.g}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  P
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.p, 'p', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.p}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle'>
                                <label className='btn btn-secondary active border-light'>
                                  A
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.a, 'a', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.a}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>HPHT & HPL</span>
                            </div>
                            <div className='col-md-8'>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  HPHT
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.hpht, 'hpht', 'date');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {moment(data.hpht).format("DD-MM-YYYY")}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  HPL
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.htp, 'htp', 'date');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {moment(data.htp).format("DD-MM-YYYY")}
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>Jumlah Anak</span>
                            </div>
                            <div className='col-md-8'>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  Hidup
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.alive_child, 'alive_child', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.alive_child}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  Mati
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.dead_child, 'dead_child', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.dead_child}
                                </button>
                              </div>
                              <div className='btn-group btn-group-toggle mr-2'>
                                <label className='btn btn-secondary active border-light'>
                                  Prematur
                                </label>
                                <button
                                  onClick={() => {
                                    putSpecisif(data.id, data.premature_child, 'premature_child', 'number');
                                  }}
                                  className='btn btn-secondary border-light'>
                                  {data.premature_child}
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>Tahun pernikahan</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.married_year, 'married_year', 'number');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.married_year}
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>
                                Jarak dengan persalinan sebelumnya
                              </span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.childbirth_interval, 'childbirth_interval', 'number');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.childbirth_interval} tahun
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>LILA</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.lila, 'lila', 'number');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.lila} cm
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>
                                Berat badan sebelum hamil
                              </span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.weight, 'weight', 'number');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.weight} kg
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>Tinggi badan</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.height, 'height', 'number');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.height} cm
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>IMT</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                className='btn btn-secondary border-light'>
                                {data.imt ?? ''}
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>Screening imunisasi TT</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.immunization_screening_tt, 'immunization_screening_tt', 'text', ['tt1', 'tt2', 'tt3', 'tt4', 'tt5']);
                                }}
                                className='btn btn-secondary border-light'>
                                {data.immunization_screening_tt}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className='list-group-item mt-0 mb-0'>
                          <div className='h4 text-center'>
                            FAKTOR RISIKO & KOMPLIKASI
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>Faktor Risiko</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.risk_factor, 'risk_factor', 'text');
                                }}
                                className='btn btn-secondary border-light'>
                                {data.risk_factor === '' ? '-' : data.risk_factor}
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                            <div className='col-md-4'>
                              <span className=''>Komplikasi</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.complication, 'complication', 'text');
                                }}
                                className='btn btn-secondary border-light'>
                                <span className='h4'>{data.complication === '' ? '-' : data.complication}</span>
                              </button>
                            </div>
                          </div>

                          <div className='row pb-2 pt-2 ml-1 mr-1'>
                            <div className='col-md-4'>
                              <span className=''>Ditemukan Oleh</span>
                            </div>
                            <div className='col-md-8'>
                              <button
                                onClick={() => {
                                  putSpecisif(data.id, data.found_by, 'found_by', 'text', ['nakes', 'masyarakat']);
                                }}
                                className='btn btn-secondary border-light'>
                                {data.found_by}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className='list-group-item mt-0 mb-0'>
                          <div className='h4 text-center mb-4'>
                            RIWAYAT KEHAMILAN YANG LALU
                          </div>
                          <Table
                            className='table table-responsive'
                            headers={[
                              "No",
                              "Menu",
                              "Abortus",
                              "Preterm",
                              "Aterm",
                              "Postterm",
                              "Cara Persalinan",
                              "Penolong Persalinan",
                              "Kondisi Bayi",
                              "Sex",
                              "BBL",
                              "Menyusui s/d",
                              "Kondisi Nifas",
                              "Keterangan",
                            ]}
                            data={data?.pregnant_history}
                            columnMapper={(datas) => [
                              datas.log ? (
                                <span class='btn btn-sm btn-block btn-outline-danger'>
                                  DELETED
                                </span>
                              ) : (
                                <>
                                  {createButton(datas.id)}
                                  {createButtonDelete(datas.id)}
                                </>
                              ),
                              datas.abortus,
                              datas.preterm,
                              datas.aterm,
                              datas.postterm,
                              datas.deliveries?.name,
                              datas.paramedic_types?.name,
                              datas.baby_condition,
                              datas.sexs?.name,
                              datas.weight,
                              datas.breast_feeding,
                              datas.nifas_condition,
                              datas.explanation,
                            ]}
                            issearch={false}
                            pagination={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='card-footer'>
                      <div className='row pb-2 pt-2 ml-1 mr-1'>
                        <button
                          className='btn btn-outline-default mb-2'
                          data-toggle='collapse'
                          data-target={"#collapsePregnant" + key}
                          aria-expanded='false'
                          aria-controls={"collapsePregnant" + key}
                          onClick={(e) => console.log(e)}>
                          Tambah Riwayat Kehamilan
                        </button>
                        <button
                          className='btn btn-danger mb-2'
                          onClick={(e) => {
                            confirmedAlert(
                              "Konfirmasi",
                              "Apakah anda akan menghapus data kehamilan?",
                              function (confirmed) {
                                if (confirmed) {
                                  delParam(data.id);
                                  // NO
                                }
                              }
                            );
                          }}>
                          Hapus Data Kehamilan
                        </button>
                      </div>
                    </div>
                    <div className='collapse' id={"collapsePregnant" + key}>
                      <div className='card-footer bg-secondary'>
                        <div className='align-items-center'>
                          <div className='list-group mb-4'>
                            <div className='list-group-item mt-0 mb-0'>
                              <div className='row'>
                                <div className='col-12'>
                                  <label className='form-control-label'>
                                    Riwayat Hamil
                                  </label>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Abortus
                                        </span>
                                      </div>
                                      <input
                                        type='number'
                                        value={history.abortus}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            abortus: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Preterm
                                        </span>
                                      </div>
                                      <input
                                        type='number'
                                        value={history.preterm}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            preterm: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Aterm
                                        </span>
                                      </div>
                                      <input
                                        type='number'
                                        value={history.aterm}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            aterm: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Postterm
                                        </span>
                                      </div>
                                      <input
                                        type='number'
                                        value={history.postterm}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            postterm: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-12'>
                                  <label className='form-control-label'>
                                    Riwayat Partus
                                  </label>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Cara Persalinan
                                        </span>
                                      </div>
                                      <Select2
                                        className='form-control p-0 pt-1'
                                        styles={{
                                          control: (styles) => ({
                                            ...styles,
                                            backgroundColor: "white",
                                            border: "none",
                                          }),
                                        }}
                                        value={history.delivery_method}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            delivery_method_id: e.value,
                                            delivery_method: e,
                                          })
                                        }
                                        options={delivery.map((data) => ({
                                          value: data.id,
                                          label: data.name,
                                        }))}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Penolong Persalinan
                                        </span>
                                      </div>
                                      <Select2
                                        className='form-control p-0 pt-1'
                                        styles={{
                                          control: (styles) => ({
                                            ...styles,
                                            backgroundColor: "white",
                                            border: "none",
                                          }),
                                        }}
                                        value={history.paramedic_types}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            paramedic_type_id: e.value,
                                            paramedic_types: e,
                                          })
                                        }
                                        options={paramedic.map((data) => ({
                                          value: data.id,
                                          label: data.name,
                                        }))}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Kondisi Bayi
                                        </span>
                                      </div>
                                      <div className='form-control'>
                                        <div className='custom-control custom-radio custom-control-inline'>
                                          <input
                                            type='radio'
                                            id={"customRadioInlineb1" + key}
                                            name={"customRadioInlineb" + key}
                                            className='custom-control-input'
                                            value='hidup'
                                            checked={
                                              history.baby_condition === "hidup"
                                                ? "checked"
                                                : ""
                                            }
                                            onChange={(e) => {
                                              setHistory({
                                                ...history,
                                                baby_condition: e.target.value,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor={
                                              "customRadioInlineb1" + key
                                            }
                                            className='custom-control-label'>
                                            Hidup
                                          </label>
                                        </div>
                                        <div className='custom-control custom-radio custom-control-inline'>
                                          <input
                                            type='radio'
                                            id={"customRadioInlineb2" + key}
                                            name={"customRadioInlineb" + key}
                                            className='custom-control-input'
                                            value='mati'
                                            checked={
                                              history.baby_condition === "mati"
                                                ? "checked"
                                                : ""
                                            }
                                            onChange={(e) => {
                                              setHistory({
                                                ...history,
                                                baby_condition: e.target.value,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor={
                                              "customRadioInlineb2" + key
                                            }
                                            className='custom-control-label'>
                                            Mati
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Sex
                                        </span>
                                      </div>
                                      <Select2
                                        className='form-control p-0 pt-1'
                                        styles={{
                                          control: (styles) => ({
                                            ...styles,
                                            backgroundColor: "white",
                                            border: "none",
                                          }),
                                        }}
                                        value={history.s}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            sex: e.value,
                                            s: e,
                                          })
                                        }
                                        options={sex.map((data) => ({
                                          value: data.id,
                                          label: data.name,
                                        }))}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-3'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          BBL
                                        </span>
                                      </div>
                                      <input
                                        type='number'
                                        value={history.weight}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            weight: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                      <div className='input-group-append'>
                                        <span className='input-group-text bg-secondary'>
                                          gr
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-12'>
                                  <label className='form-control-label'>
                                    Riwayat Nifas
                                  </label>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Menyusui s/d
                                        </span>
                                      </div>
                                      <input
                                        type='text'
                                        value={history.breast_feeding}
                                        onChange={(e) =>
                                          setHistory({
                                            ...history,
                                            breast_feeding: e.target.value,
                                          })
                                        }
                                        className='form-control'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='col-md-6'>
                                  <div className='form-group'>
                                    <div className='input-group'>
                                      <div className='input-group-prepend'>
                                        <span className='input-group-text text-white bg-default border-default'>
                                          Kondisi Nifas
                                        </span>
                                      </div>
                                      <div className='form-control'>
                                        <div className='custom-control custom-radio custom-control-inline'>
                                          <input
                                            type='radio'
                                            id={"customRadioInlinen1" + key}
                                            name={"customRadioInlinen" + key}
                                            className='custom-control-input'
                                            value='sehat'
                                            checked={
                                              history.nifas_condition ===
                                                "sehat"
                                                ? "checked"
                                                : ""
                                            }
                                            onChange={(e) => {
                                              setHistory({
                                                ...history,
                                                nifas_condition: e.target.value,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor={
                                              "customRadioInlinen1" + key
                                            }
                                            className='custom-control-label'>
                                            Sehat
                                          </label>
                                        </div>
                                        <div className='custom-control custom-radio custom-control-inline'>
                                          <input
                                            type='radio'
                                            id={"customRadioInlinen2" + key}
                                            name={"customRadioInlinen" + key}
                                            className='custom-control-input'
                                            value='sakit'
                                            checked={
                                              history.nifas_condition ===
                                                "sakit"
                                                ? "checked"
                                                : ""
                                            }
                                            onChange={(e) => {
                                              setHistory({
                                                ...history,
                                                nifas_condition: e.target.value,
                                              });
                                            }}
                                          />
                                          <label
                                            htmlFor={
                                              "customRadioInlinen2" + key
                                            }
                                            className='custom-control-label'>
                                            Sakit
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='col-12'>
                                  <div className='form-group'>
                                    <label className='form-control-label'>
                                      Keterangan
                                    </label>
                                    <textarea
                                      className='form-control'
                                      onChange={(e) =>
                                        setHistory({
                                          ...history,
                                          explanation: e.target.value,
                                        })
                                      }
                                      value={history.explanation}
                                      rows='3'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            className='btn btn-default mb-2'
                            onClick={() => postHistory(data.id)}>
                            Simpan Data Riwayat Kehamilan
                          </button>
                          <button
                            className='btn btn-outline-dark mb-2'
                            data-toggle='collapse'
                            data-target={"#collapsePregnant" + key}
                            aria-expanded='false'
                            aria-controls={"collapsePregnant" + key}>
                            Tutup
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )
            )}
          </div>
        </div>
      </div>
      <div className='accordion' id='accordionLog'>
        <div className='card'>
          <div
            className='card-header'
            id={"heading"}
            data-toggle='collapse'
            data-target={"#collapse"}
            aria-expanded='false'
            aria-controls={"collapse"}>
            <div className='h3 text-default mb-0'>Log Riwayat Kehamilan</div>
          </div>
          <div
            id={"collapse"}
            className='collapse'
            aria-labelledby={"heading"}
            data-parent='#accordionLog'>
            <div className='card-body bg-light'>
              <div className='accordion'>
                {refPregnantHistory.map((data, key) =>
                  data.log === true ? (
                    <div className='card' key={key}>
                      <div
                        className='card-header collapsed'
                        id={"headinglab" + key}
                        data-toggle='collapse'
                        data-target={"#collapselab" + key}
                        aria-expanded='false'
                        aria-controls={"collapselab" + key}>
                        <div className='row align-items-center'>
                          <div className='col'>
                            <div className='mb-0 text-default'>
                              Tanggal Kunjungan{" "}
                              {moment(data.created_at).format(
                                "YYYY-MM-DD HH:mm"
                              )}
                            </div>
                            <div className='h3 mb-0 text-default h4'>
                              Paramedis {data.users.name}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className='collapse'
                        id={"collapselab" + key}
                        aria-labelledby={"headinglab" + key}>
                        <div className='card-body'>
                          <div className='list-group mb-4'>
                            <div className='list-group-item mt-0 mb-0'>
                              <div className='h4 text-center text-danger'>
                                DETAIL KEHAMILAN
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                {data.medical_facilities_other ? (
                                  <>
                                    <div className='col-12'>
                                      <span className=''>
                                        Berkunjung ke nakes lain sebelumnya
                                      </span>
                                    </div>
                                    <div className='col-1'></div>
                                    <div className='col-3'>
                                      <span className=''>Umur Kehamilan</span>
                                    </div>
                                    <div className='col-8'>
                                      <span className='h4'>
                                        {data.medical_facilities_other_age}{" "}
                                        minggu
                                      </span>
                                    </div>
                                    <div className='col-1'></div>
                                    <div className='col-3'>
                                      <span className=''>Tempat</span>
                                    </div>
                                    <div className='col-8'>
                                      <span className='h4'>
                                        {data.health_facilities?.name}
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className='col-12'>
                                      <span className='text-muted'>
                                        Tidak berkunjung ke nakes lain
                                        sebelumnya
                                      </span>
                                    </div>
                                  </>
                                )}
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>Riwayat Persalinan</span>
                                </div>
                                <div className='col-md-8'>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      G
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.g}
                                    </label>
                                  </div>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      P
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.p}
                                    </label>
                                  </div>
                                  <div className='btn-group btn-group-toggle'>
                                    <label className='btn btn-secondary active border-light'>
                                      A
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.a}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>HPHT & HPL</span>
                                </div>
                                <div className='col-md-8'>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      HPHT
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {moment(data.hpht).format("DD-MM-YYYY")}
                                    </label>
                                  </div>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      HPL
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {moment(data.htp).format("DD-MM-YYYY")}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>Jumlah Anak</span>
                                </div>
                                <div className='col-md-8'>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      Hidup
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.alive_child}
                                    </label>
                                  </div>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      Mati
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.dead_child}
                                    </label>
                                  </div>
                                  <div className='btn-group btn-group-toggle mr-2'>
                                    <label className='btn btn-secondary active border-light'>
                                      Prematur
                                    </label>
                                    <label className='btn btn-secondary border-light'>
                                      {data.premature_child}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>Tahun pernikahan</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.married_year}
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>
                                    Jarak dengan persalinan sebelumnya
                                  </span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.childbirth_interval} tahun
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>LILA</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.lila} cm
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>
                                    Berat badan sebelum hamil
                                  </span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.weight} kg
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>Tinggi badan</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.height} cm
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>
                                    Screening imunisasi TT
                                  </span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.immunization_screening_tt}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className='list-group-item mt-0 mb-0'>
                              <div className='h4 text-center text-danger'>
                                FAKTOR RISIKO & KOMPLIKASI
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>Faktor Risiko</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.risk_factor}
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1 bg-secondary'>
                                <div className='col-md-4'>
                                  <span className=''>Komplikasi</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4'>
                                    {data.complication}
                                  </span>
                                </div>
                              </div>

                              <div className='row pb-2 pt-2 ml-1 mr-1'>
                                <div className='col-md-4'>
                                  <span className=''>Ditemukan Oleh</span>
                                </div>
                                <div className='col-md-8'>
                                  <span className='h4 text-default'>
                                    {data.found_by}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className='list-group-item mt-0 mb-0'>
                              <div className='h4 text-center text-danger'>
                                RIWAYAT KEHAMILAN YANG LALU
                              </div>
                              <Table
                                className='table table-responsive'
                                headers={[
                                  "No",
                                  "Abortus",
                                  "Preterm",
                                  "Aterm",
                                  "Postterm",
                                  "Cara Persalinan",
                                  "Penolong Persalinan",
                                  "Kondisi Bayi",
                                  "Sex",
                                  "BBL",
                                  "Menyusui s/d",
                                  "Kondisi Nifas",
                                  "Keterangan",
                                  "Menu",
                                ]}
                                data={data.pregnant_history}
                                columnMapper={(datas, key) => [
                                  datas.abortus,
                                  datas.preterm,
                                  datas.aterm,
                                  datas.postterm,
                                  datas.deliveries.name,
                                  datas.paramedic_types.name,
                                  datas.baby_condition,
                                  datas.sexs.name,
                                  datas.weight,
                                  datas.breast_feeding,
                                  datas.nifas_condition,
                                  datas.explanation,
                                ]}
                                issearch={false}
                                pagination={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PregnantHistory;
